var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArticles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 49,
    viewBox: "0 0 52 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5143 47.9999H9.31834C9.31834 47.9999 1 48.0994 1 39.6232C1 31.1448 1 1 1 1",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9122 39.6827C50.9122 48.0043 43.6753 47.9999 43.6753 47.9999C43.6753 47.9999 35.357 47.9708 35.357 39.6232C35.357 31.2757 35.357 1 35.357 1H1C1 1 1 31.1448 1 39.6232C1 48.0994 9.31834 47.9999 9.31834 47.9999H42.5939",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5938 38.6864V12.4834C42.5938 12.4834 42.6911 8.32422 46.7529 8.32422C50.8148 8.32422 50.9132 12.5418 50.9132 12.5418V39.6856",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7513 8.27148H36.5059",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7125 39.6779H28.0319M7.23497 27.1993H14.5562H7.23497ZM7.23497 22.8736H14.5562H7.23497ZM7.23497 31.525H14.5562H7.23497ZM7.23497 35.8507H14.5562H7.23497ZM7.23497 40.1765H14.5562H7.23497ZM19.7125 27.1993H28.0319H19.7125ZM19.7125 22.8736H28.0319H19.7125ZM6.73535 14.2222H28.0319H6.73535ZM6.73535 9.89648H28.0319H6.73535ZM19.7125 31.2763H28.0319H19.7125ZM19.7125 35.602H28.0319H19.7125Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticles);
export default __webpack_public_path__ + "static/media/articles.916c6fd6.svg";
export { ForwardRef as ReactComponent };